export default __webpack_public_path__ + "static/media/design-3.44216843.png";